
export default function ModalMessageOkDialog() {

    return (
        <></>
    )
}
